import { SideBarStyle, VersionTag } from '../../styles';
import { ROUTES_MENU } from '../../../../resources/routes-name';
import { useSelectMenu } from '../../hooks/useSelectMenu';
import { Divider, Menu, Tag } from 'antd';
import { ScrollMenu } from './style';
import { color, VERSION } from '../../../../resources';

const SiderLayout = ({ collapsed, getTheme, sidebarMode }) => {
  const { defaultSelectedKeys, defaultOpenKeys, onHandleClick } = useSelectMenu();
  return (
    <SideBarStyle
      trigger={null}
      width={280}
      collapsible
      collapsed={collapsed}
      style={{
        ...getTheme.sidebar[sidebarMode],
        backgroundColor: color.black_why,
      }}
    >
      <div className="logo">
        <img src={`../../assets/images/why_logo.jpg`} alt="Avatar" class="avatar" />
      </div>
      <VersionTag collapse={collapsed}>
        <Tag style={{ margin: 0, color: '#000' }} color="green">
          version: {VERSION}
        </Tag>
      </VersionTag>
      <Divider />
      {defaultOpenKeys && defaultSelectedKeys && (
        <ScrollMenu>
          <Menu
            theme={sidebarMode}
            mode="inline"
            defaultOpenKeys={defaultOpenKeys}
            defaultSelectedKeys={defaultSelectedKeys}
            style={{ ...getTheme.sidebar[sidebarMode], backgroundColor: color.black_why }}
            items={ROUTES_MENU.filter((e) => !e.hidden)}
            onClick={onHandleClick}
          />
        </ScrollMenu>
      )}
    </SideBarStyle>
  );
};

export default SiderLayout;
